// src/pages/About.js
import React from 'react';
import { motion } from 'framer-motion';
import '../styles/About.css';

function About() {
  return (
    <motion.div
      className="about-page"
      initial={{ opacity: 0, x: -30 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.9, ease: 'easeOut' }}
    >
      <h1>About Dark chain legion</h1>
      <h2>Where AI, art, and Web3 evolve together.</h2>

      <p>
        Dark chain legion is a next-gen, 3D animated NFT project built on the Monad blockchain — designed to unite creativity, artificial
        intelligence, and blockchain culture. It’s more than a collection. It’s a living ecosystem where each NFT is a key to
        powerful AI tools and a gateway into the lore of the Darkchain Legion.
      </p>

      <hr className="section-divider" />

      <h3>🧠 What Makes Dark chain legion Unique:</h3>
      <p>• 3,333 uniquely crafted characters in a rogue, LEGO-style undead universe</p>
      <p>• Direct access to our AI Image Generator and AI Chat Assistant</p>
      <p>• Tools for holders to create art, lore, and content powered by their NFTs</p>
      <p>• IP ownership: use your character in stories, videos, merch, and more</p>
      <p>• A growing ecosystem inspired by the Monad chain’s speed and power</p>

      <hr className="section-divider" />

      <h3>🚀 Beyond NFTs – The Ecosystem:</h3>
      <p>Dark chain legion App evolves alongside the community:</p>
      <p>• Create stunning art with text-to-image & image-to-video tools</p>
      <p>• Collaborate, compete, and build in the Darkchain Lore</p>
      <p>• Future upgrades: AR/VR tools, AI-powered storytelling, and more</p>
      <p>• Treasury-backed roadmap with long-term sustainability</p>

      <hr className="section-divider" />

      <p className="closing-statement">
        Dark chain legion isn’t just a collection. It’s a movement — for builders, artists, rebels, and undead visionaries shaping the
        next wave of on-chain creativity.
      </p>

      <h2 className="tagline">Enter the Dark. Create with AI. Shape the Future.</h2>
    </motion.div>
  );
}

export default About;
